import React from 'react';
import Addicon from '../../media/add.png';
import { Image, Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Buttons from '@material-ui/core/Button';
import ViewCombo from './viewcombo';



class View extends React.Component {

  state = {
    file: Addicon,
  }

  componentDidMount() {
    if (this.props.item.image) {
      this.setState({
        file: this.props.item.image,
      });
    }
    else {
      this.setState({
        file: Addicon,
      });
    }
  }

  handleFile = e => {
    
    this.updateLocalfile(e.target.files[0]);
    this.uploadimage(e.target.files[0])
  }

  uploadimage(file) {
    let context = this;
    if (this.props.item.image) {
      let categoryId = this.props.item.id;
      let oldImage = this.props.item.image_name+".jpg";
      var formData = new FormData();
      formData.append('file', file);
      formData.append('oldfile', oldImage);
      $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'combo/updateimage.php',
      success: function(data)
      {
      },
      error: function(error) {
      }
      });
    }
    else {
      let categoryId = this.props.item.id;
      var formData = new FormData();
      formData.append('id', categoryId);
      formData.append('file', file);
      $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'combo/addimage.php',
      success: function(data)
      {
      },
      error: function(error) {
      }
      });
    }
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  openChangeStatusDialog(id) {
    this.setState({ changeStatusId: id, openDialog: true })
  }

  activeOptionMenu = (id) => (f, { value }) => {
    let context = this;
    $.ajax({
      type: 'POST', data: { id, value },
      url: Server() + 'combo/changestatus.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          context.props.getCombos();
          context.setState({ openDialog: false })
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  deleteCombo(id) {
    let context = this;
    $.ajax({
      type: 'POST', data: { id },
      url: Server() + 'combo/deletecombo.php',
      success: function(data) {
        context.setState({ load: false })
        if (data == 1) {
          context.props.getCombos();
          context.setState({ openDialog: false })
        }
        else {
          alert('Error!!!')
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  

  render() {
    let  { openDialog } = this.state;
    const { fullScreen } = this.props;
    let status = [
      {key: 'Active', text: 'Active', value: 'Active'},
      {key: 'Inactive', text: 'Inactive', value: 'Inactive'},
    ]
    return (
      <tbody>
        <tr>
          <td><center>{this.props.sino}</center></td>
          <td><center>{this.props.item.combo_name}</center></td>
          <td>
            <center>
              <input id={this.props.item.id} type="file" onChange={this.handleFile} style={{display: 'none'}}/>
              <label htmlFor={this.props.item.id}>
                <Image src={this.state.file} size='small'
                style={{width: 80, height: 50, cursor: 'pointer'}}
                id='image' />
              </label>
            </center>
          </td>
          <td onClick={this.openChangeStatusDialog.bind(this, this.props.item.id)}><center>{this.props.item.status}</center></td>
          <td><center>{this.props.item.priority}</center></td>
          <td>
            <center><ViewCombo menuPermission={this.props.menuPermission} id={this.props.item.id} name={this.props.item.combo_name} /></center>
          </td>
          <td onClick={this.deleteCombo.bind(this, this.props.item.id)}><center style={{color: 'red'}}>Delete</center></td>
              
          
        </tr>

        <Dialog fullScreen={fullScreen} open={openDialog}
          onClose={ () => { this.setState({ openDialog: false }) }} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 400}}>{"Change Status"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
                <Dropdown placeholder='Status' style={{ borderColor: '#5A9CBB' }}
                          search selection onChange={this.activeOptionMenu(this.props.item.id)} fluid
                          options={status} value={this.props.item.status} />

              <br/><br/><br/>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Buttons onClick={ () => { this.setState({ openDialog: false }) }} color="secondary">
              Close
            </Buttons>
          </DialogActions>
        </Dialog>

      </tbody>
    );
  }
}

export default View;
